import { http } from '../../../api/http';
import type {
  MovimientoCajaRequest,
  MovimientoCajaResponse,
  ResumenCajaResponse,
} from '../types/pos.types';

export class PosCajaService {
  private static readonly ENDPOINTS = {
    MOVIMIENTO: '/pos/caja/movimiento',
    MOVIMIENTOS: '/pos/caja/movimientos',
    RESUMEN: '/pos/caja/resumen',
  };

  public static async registrarMovimiento(data: MovimientoCajaRequest): Promise<MovimientoCajaResponse> {
    try {
      const response = await http.post(this.ENDPOINTS.MOVIMIENTO, data);
      return response.data;
    } catch (error) {
      console.error('Error al registrar movimiento:', error);
      throw error;
    }
  }

  public static async getMovimientos(): Promise<MovimientoCajaResponse[]> {
    try {
      const response = await http.get(this.ENDPOINTS.MOVIMIENTOS);
      return response.data;
    } catch (error) {
      console.error('Error al obtener movimientos:', error);
      throw error;
    }
  }

  public static async getResumen(): Promise<ResumenCajaResponse> {
    try {
      const response = await http.get(this.ENDPOINTS.RESUMEN);
      return response.data;
    } catch (error) {
      console.error('Error al obtener resumen:', error);
      throw error;
    }
  }
}
